export const legalData = {
  en: {
    title: 'Legal bits',
    addressTitle: 'Registered Office',
    companyTitle: 'Company Number',
    companyName: 'Apprentus Ltd.',
    addressLines: ['20-22 Wenlock Road', 'London', 'N1 7GU', 'England'],
    companyNumber: '08897308'
  },
  nl: {
    title: 'Juridische informatie',
    addressTitle: 'Hoofdzetel',
    companyTitle: 'Bedrijfsnummer',
    companyName: 'Apprentus Ltd.',
    addressLines: ['20-22 Wenlock Road', 'London', 'N1 7GU', 'England'],
    companyNumber: '08897308'
  }
}
